import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
  Container,
  useTheme,
  useMediaQuery,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

interface NavbarProps {
  specialistName: string;
  specialistTitle: string;
  avatarSrc?: string;
}

export const Navbar: React.FC<NavbarProps> = ({
  specialistName,
  specialistTitle,
  avatarSrc,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const navItems = ["Benefícios", "Planos", "Depoimentos", "FAQ"];

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "white",
        boxShadow:
          "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        py: 1,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {avatarSrc && (
              <Avatar
                alt={specialistName}
                src={avatarSrc}
                sx={{
                  mr: 1.5,
                  width: 40,
                  height: 40,
                  border: `2px solid ${theme.palette.primary.main}`,
                }}
              />
            )}
            <Box>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", color: "text.primary" }}
              >
                {specialistName}
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {specialistTitle}
              </Typography>
            </Box>
          </Box>

          {!isMobile && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {navItems.map((item) => (
                <Button
                  key={item}
                  sx={{
                    mx: 1,
                    color: "text.primary",
                    "&:hover": {
                      color: theme.palette.primary.main,
                      backgroundColor: "transparent",
                    },
                  }}
                  href={`#${item.toLowerCase()}`}
                >
                  {item}
                </Button>
              ))}
            </Box>
          )}

          <Button
            variant="contained"
            href="#formulario"
            startIcon={<WhatsAppIcon />}
            sx={{
              backgroundColor: theme.palette.secondary.main,
              color: "white",
              borderRadius: "8px",
              fontWeight: "bold",
              px: isMobile ? 2 : 3,
              py: 1,
              "&:hover": {
                backgroundColor: theme.palette.secondary.dark,
              },
              display: { xs: "none", sm: "flex" },
            }}
          >
            Falar agora
          </Button>

          {isMobile && (
            <IconButton
              color="primary"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </Container>

      {/* Menu Móvel */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        sx={{
          "& .MuiDrawer-paper": {
            width: "70%",
            maxWidth: "300px",
            boxSizing: "border-box",
            p: 2,
          },
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
          <IconButton onClick={handleDrawerToggle}>
            <CloseIcon />
          </IconButton>
        </Box>
        <List>
          {navItems.map((item) => (
            <ListItem
              button
              key={item}
              onClick={handleDrawerToggle}
              component="a"
              href={`#${item.toLowerCase()}`}
            >
              <ListItemText primary={item} />
            </ListItem>
          ))}
          <ListItem sx={{ mt: 2 }}>
            <Button
              variant="contained"
              href="#formulario"
              startIcon={<WhatsAppIcon />}
              fullWidth
              sx={{
                backgroundColor: theme.palette.secondary.main,
                color: "white",
                py: 1,
                "&:hover": {
                  backgroundColor: theme.palette.secondary.dark,
                },
              }}
            >
              Falar agora
            </Button>
          </ListItem>
        </List>
      </Drawer>
    </AppBar>
  );
};
